<template>
  <a-tabs type="card" v-model="active" @change="callback">
    <a-tab-pane key="1" tab="已发布课程">
      <published ref="published" @changeTab="changeTab"></published>
    </a-tab-pane>
    <a-tab-pane key="2" tab="未发布课程">
      <unpublished ref="unpublished"></unpublished>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import published from './published.vue'
import unpublished from './unpublished.vue'
export default {
  data() {
    return {
      active: '1',
    }
  },
  components: {
    published,
    unpublished,
  },
  mounted() {
    // this.$refs.published.init()
    this.active = this.$route.query.select ? String(this.$route.query.select) : '1'
    if (this.active == 1) {
      this.$nextTick((res) => {
        this.$refs.published.init()
      })
    } else if (this.active == 2) {
      this.$nextTick((res) => {
        this.$refs.unpublished.init()
      })
    }
    // if (this.$store.getters.uploadFilestatus == 'uploading') {
    //   let _this = this
    //   this.$confirm({
    //     title: '提示',
    //     content: '检测到文件上传中断，是否前往?',
    //     okText: '确定',
    //     cancelText: '取消',
    //     onOk() {
    //       let file = _this.$store.getters.uploadFileInfo
    //       _this.$router.push({
    //         path: '/training/course/addcourse?uploading=1&id=' + file.courseId,
    //       })
    //     },
    //     onCancel() {
    //       _this.$message.info('取消前往')
    //     },
    //   })
    // }
  },
  methods: {
    changeTab() {
      this.active = '2'
      this.$nextTick((res) => {
        this.$refs.unpublished.init()
      })
    },
    callback(key) {
      // console.log(key)
      if (key == 1) {
        this.$nextTick((res) => {
          this.$refs.published.init()
          console.log(this.$refs.published, 'this.$refs.published')
        })
      } else if (key == 2) {
        this.$nextTick((res) => {
          this.$refs.unpublished.init()
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .ant-tabs-tabpane-active {
  height: 100% !important;
}
</style>